import { useCallback, useMemo } from "react";
import { useParams } from "react-router-dom";

import API from "Signups/API.js";
import { useSignups } from "Signups/state.js";
import { usePaymentAmountNeeded } from "Signups/stateHooks";

import convertUserSignupItemsToArray from "../SignupItem/utils/convertUserSignupItemsToArray";

import { getAllUserSignupItemIDs } from "./getAllUserSignupItemIDs";

export function useFetchPaymentAmountNeeded() {
  const [state] = useSignups();
  const { signupListID } = useParams();
  const [, setPaymentAmountNeeded] = usePaymentAmountNeeded();

  const userSignupItemsArray = useMemo(
    () => convertUserSignupItemsToArray(state.userSignupItems),
    [state.userSignupItems]
  );

  const userHasSignup = useMemo(
    () =>
      userSignupItemsArray.some((userSignupItem) => {
        return userSignupItem.respondents.length > 0;
      }),
    [userSignupItemsArray]
  );

  const userSignupItemIDs = useMemo(
    () => getAllUserSignupItemIDs(state.userSignupItems),
    [state.userSignupItems]
  );

  return useCallback(() => {
    if (!userHasSignup) return;

    API.calculatePaymentAmount({
      signupID: signupListID,
      postData: { userSignupItemIDs },
    })
      .post()
      .then(({ paymentAmountNeeded }) => {
        setPaymentAmountNeeded(paymentAmountNeeded);
      });
  }, [setPaymentAmountNeeded, signupListID, userHasSignup, userSignupItemIDs]);
}
